var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBrunoCoreBenefits3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2605_6803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.625 32.5H1.875C0.8395 32.5 0 33.3395 0 34.375V62.125C0 63.1605 0.8395 64 1.875 64H29.625C30.6605 64 31.5 63.1605 31.5 62.125V34.375C31.5 33.3395 30.6605 32.5 29.625 32.5Z",
    fill: "#FFD422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.549316 63.4506C0.72326 63.6249 0.929934 63.7632 1.15747 63.8574C1.385 63.9517 1.62891 64 1.87519 63.9997H29.6252C30.6607 63.9997 31.5002 63.1602 31.5002 62.1247V34.3747C31.5002 33.857 31.2903 33.3882 30.9511 33.0488L0.549316 63.4506Z",
    fill: "#FF9F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.125 0H19.625C18.5895 0 17.75 0.8395 17.75 1.875V44.375C17.75 45.4105 18.5895 46.25 19.625 46.25H62.125C63.1605 46.25 64 45.4105 64 44.375V1.875C64 0.8395 63.1605 0 62.125 0Z",
    fill: "#FFF36C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2993 45.7006C18.4733 45.8749 18.6799 46.0132 18.9075 46.1074C19.135 46.2017 19.3789 46.25 19.6252 46.2497H62.1252C63.1607 46.2497 64.0002 45.4102 64.0002 44.3747V1.8747C64.0002 1.35695 63.7903 0.888203 63.4511 0.548828L18.2993 45.7006Z",
    fill: "#FFD422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.625 7.5H47.125C46.0895 7.5 45.25 8.3395 45.25 9.375C45.25 10.4105 46.0895 11.25 47.125 11.25H50.0984L29 32.3484V29.375C29 28.3395 28.1605 27.5 27.125 27.5C26.0895 27.5 25.25 28.3395 25.25 29.375V36.875C25.25 37.9105 26.0895 38.75 27.125 38.75H34.625C35.6605 38.75 36.5 37.9105 36.5 36.875C36.5 35.8395 35.6605 35 34.625 35H31.6516L52.75 13.9016V16.875C52.75 17.9105 53.5895 18.75 54.625 18.75C55.6605 18.75 56.5 17.9105 56.5 16.875V9.375C56.5 8.3395 55.6605 7.5 54.625 7.5Z",
    fill: "#303183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9511 8.04883L25.7993 38.2006C25.9733 38.3749 26.1799 38.5132 26.4075 38.6074C26.635 38.7017 26.8789 38.75 27.1252 38.7497H34.6252C35.6607 38.7497 36.5002 37.9102 36.5002 36.8747C36.5002 35.8392 35.6607 34.9997 34.6252 34.9997H31.6518L52.7502 13.9013V16.8747C52.7502 17.9102 53.5897 18.7497 54.6252 18.7497C55.6607 18.7497 56.5002 17.9102 56.5002 16.8747V9.3747C56.5002 8.85695 56.2903 8.3882 55.9511 8.04883Z",
    fill: "#00429B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2605_6803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBrunoCoreBenefits3);
export default __webpack_public_path__ + "static/media/products_bruno_core_benefits_3.43f1c3bb2c64887dbd0f602d6599361c.svg";
export { ForwardRef as ReactComponent };